module.exports = __webpack_public_path__ + "img/w3_viewed_grey.3fc9a64b.png";